// @ts-strict-ignore
import { BaseArticleOperation } from '@shared/undo/operation/base-article-operation';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleModelDataHolder } from '@3d-scene/model3d/cache/model-data';
import { MetaElementUsageVO, MetaElementVO } from '@shared/vo/meta-element.vo';
import { ProjectModel } from '@project/model/project.model';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { TextureElementVO } from '@article/model/vo/texture-element.vo';

export class ReplaceArticleModelOperation extends BaseArticleOperation implements IOperation {

  constructor(
    projectModel: ProjectModel,
    private selectionModelService: SelectionModelService,
    private sceneManager: SceneManager,
    articleContainerFactory: ArticleContainerFactory,
    containerService: ContainerService,
    articleContainer: ArticleContainer,
    private _oldModelDataHolder: ArticleModelDataHolder,
    private _newModelDataHolder: ArticleModelDataHolder,
    private _removedMetaElements: MetaElementVO[],
    private _removedMetaElementUsages: MetaElementUsageVO[],
    private _removedTextureElements: TextureElementVO[],
    private _keepConnections: boolean,
    private applicationRefreshService: ApplicationRefreshService
    ) {
      super(
        projectModel,
        articleContainerFactory,
        containerService,
        articleContainer
        );
  }

  public getQualifiedClassName(): string {
    return 'ReplaceArticleModelOperation';
  }

  public getOperationDescription(): string {
    return 'replaceArticleModelOperation.description';
  }

  public async performRedo(): Promise<void> {
    await this.replaceArticleModel(this._newModelDataHolder, this._removedMetaElements, this._removedMetaElementUsages, [], this._keepConnections);
  }

  public async performUndo(): Promise<void> {
    await this.replaceArticleModel(this._oldModelDataHolder, this._removedMetaElements, this._removedMetaElementUsages, this._removedTextureElements, true);
  }

  private async replaceArticleModel(modelDataHolder: ArticleModelDataHolder, metaElements: MetaElementVO[], metaUsages: MetaElementUsageVO[], textureElements: TextureElementVO[], keepConnections): Promise<void> {
    const usage: ArticleUsageVO = this.projectModel.getCurrentLoadedArticleUsage();
    this._articleContainer.isParsed = false;
    this._articleContainer.disposeModel();

    if (keepConnections) {
      this._articleContainer.article.metaElements = metaElements;
      usage.metaElementUsages = metaUsages;
    } else {
      this._articleContainer.article.metaElements = [];
      usage.metaElementUsages = [];
    }

    this._articleContainer.article.textureElements = textureElements;

    await this._articleContainer.parseModel(modelDataHolder);
    this._articleContainer.addAxesHelper();

    await this.applicationRefreshService.refreshProject();
    this.projectModel.notifyCurrentProjectChanged();
    this.selectionModelService.removeAllSelections();
    this.sceneManager.renderScene();
    this.applicationRefreshService.notifyProjectChange();
  }
}
